import { render, staticRenderFns } from "./ImageGalleryModal.vue?vue&type=template&id=47c59efe&scoped=true"
import script from "./ImageGalleryModal.vue?vue&type=script&lang=js"
export * from "./ImageGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./ImageGalleryModal.vue?vue&type=style&index=0&id=47c59efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c59efe",
  null
  
)

export default component.exports